import React, { useState } from "react";
import Breadcrumb from "../../../../Components/Breadcrumb/Breadcrumb";
import branchData from "./branchData.json";
import UploadFileInstruction from "../../../../Components/UploadFileInstruction/UploadFileInstruction";
import axios from "axios";
import Cookies from "js-cookie";
import EvnVar from "../../../../EnvVar";

const UploadingCSV = () => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const baseURL = EvnVar();
  const token = Cookies.get("jwt");

  const handleSubmitFile = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const file = formData.get("file");
    const selectedBranchName = formData.get("branch");
    const selectedBranch = branchData.filter(
      (branch) => branch.name === selectedBranchName
    );

    let branchId = null;
    if (selectedBranch) {
      const [selectedBranchItem] = selectedBranch;
      branchId = selectedBranchItem.id;
    }

    if (file && file.type === "text/csv") {
      const reader = new FileReader();

      reader.onload = function (e) {
        const csvContent = e.target.result;
        const jsonData = csvToJSON(csvContent);
        sendDataToAPI(jsonData, branchId);
        event.target.reset();
      };
      reader.readAsText(file);
      setError("");
    } else {
      setError("Select CSV file first then click on submit.");
    }
  };

  const csvToJSON = (csv) => {
    const lines = csv.split("\n");
    const result = [];

    const headers = lines[0].split(",");

    for (let i = 1; i < lines.length; i++) {
      let obj = {};
      const currentLine = lines[i].split(",");

      headers.forEach((header, index) => {
        obj[header.trim()] = currentLine[index]?.trim();
      });

      if (
        Object.keys(obj).length > 0 &&
        currentLine.length === headers.length
      ) {
        result.push(obj);
      }
    }

    return result;
  };

  const sendDataToAPI = (csvData, branch) => {
    const csvFileData = csvData.map((value) => {
      return {
        name: value.name,
        city: value.city,
        gender: value.gender,
        mobile: value.mobile,
        email: value.email,
        pincode: value.pincode,
        description: "",
      };
    });

    const payload = {
      attendance: csvFileData,
      branchId: branch,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/user/uploadAttendance`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      data: JSON.stringify(payload),
      withCredentials: true,
    };

    axios
      .request(config)
      .then((response) => {
        setSuccess(response.data.message);
        setTimeout(() => {
          setSuccess("");
        }, 2000);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <Breadcrumb data="Upload File" />
      <div className="content-body">
        <div className="table-data">
          <UploadFileInstruction />
          <form onSubmit={handleSubmitFile} className=" mt-4">
            <div className="row">
              <div className="col-md-6">
                <label className=" mb-2 fw-bold text-black-50" htmlFor="file">
                  Upload CSV File
                </label>
                <input type="file" name="file" id="file" accept=".csv" />
                {error && <p className="mb-0 mt-3 text-danger">{error}</p>}
              </div>
              <div className="col-md-6">
                <label className=" mb-2 fw-bold text-black-50" htmlFor="branch">
                  Select Branch
                </label>
                <select id="branch" name="branch">
                  {branchData &&
                    branchData.map((value, index) => {
                      return (
                        <option value={value.name} id={value.id} key={index}>
                          {value.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
            <button type="submit" className="download-btn mt-3">
              Submit
            </button>
            {success && (
              <p className=" text-success mt-2 mb-0 fw-bold">{success}!</p>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default UploadingCSV;
